import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export function SheetHeader({ className, children }: ComponentProps<'div'>) {
  return <div className={twMerge('flex-shrink-0 border-b p-6', className)}>{children}</div>
}
